import { useState } from 'react';
import './Drawer.css';

const Drawer = ({ 
  heading='', 
  isOpen, 
  onClose, 
  children, 
  isExpandable=true,
  width=650 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [currentWidth, setCurrentWidth] = useState(width);
  
  const toggleExpand = () => {
    if (isExpanded) {
      setCurrentWidth(width);
    }
    else {
      setCurrentWidth('100%');
    }
    setIsExpanded(!isExpanded);
  };
  return (
    <div className="modal-overlay">
      <div  className={`drawer ${isOpen ? 'open' : ''}`}
        style={{  width: isOpen ? currentWidth : width, right: isOpen ? 0 : -width }}
      >
        {isExpandable && (
          <button className="expand-button" onClick={toggleExpand}>
            {isExpanded ? (
              <i className="bx bx-chevron-right" />
            ) : (
              <i className="bx bx-chevron-left" />
            )}
          </button>
        )}
        <div className="drawer-header">
          {heading && <h2>{heading}</h2>}
          <button className="close-button" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="drawer-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Drawer;
